export default __webpack_public_path__ + "es-MX.50e841db.csv";